// @ts-nocheck


import React, { Component } from 'react';
import Input from 'antd/lib/input/Input';
import styled from 'styled-components';
import isEmpty from 'lodash/isEmpty';


import { Popconfirm, Icon, ListTable } from '../../../components/ui';
import { DateTimePicker } from '../../../components';
import { withEmptyRow } from '../../../lib/helpers';
import { loadUnloadCargoApi } from '../../../lib/api';

const StyledIcon = styled(Icon).withConfig({ displayName: "LoadUnloadsForm__StyledIcon", componentId: "sc-1w5ncjc-0" })(["cursor:pointer;"]);


const Operations = styled.div.withConfig({ displayName: "LoadUnloadsForm__Operations", componentId: "sc-1w5ncjc-1" })(["display:flex;align-items:center;justify-content:center;height:100%;"]);






const { TextArea } = Input;






/**
 * Компонент отображает список прикрепленных к заявке по доп. найму ТС погрузок/разгрузок
 */
class LoadUnloadCargosForm extends Component {
  static defaultProps = {
    loadUnloads: []
  };

  onChange(index, key, value) {
    let loadUnloads = withEmptyRow([...this.props.loadUnloads]);
    loadUnloads.splice(index, 1, {
      ...loadUnloads[index],
      [key]: value
    });
    this.props.onChange(loadUnloads);
  }

  onDelete(index) {
    this.props.onChange(
      this.props.loadUnloads.filter((value, id) => id !== index)
    );
  }

  render() {
    const { loadUnloads } = this.props;
    return (
      <ListTable
        columns={[
        {
          title: 'Адрес',
          key: 'address',
          render: (
          address,
          record,
          index) =>

          <Input
            onChange={(e) =>
            this.onChange(index, 'address', e.target.value)
            }
            value={address}
            name="name"
            placeholder="Введите адрес" />


        },
        {
          title: 'Начало',
          key: 'startDateTime',
          width: '210px',
          render: (
          startDateTime,
          record,
          index) =>

          <DateTimePicker
            onChange={(dateTime) =>
            this.onChange(index, 'startDateTime', dateTime)
            }
            value={startDateTime}
            name="startDateTime" />


        },
        {
          title: 'Конец',
          key: 'endDateTime',
          width: '210px',
          render: (
          endDateTime,
          record,
          index) =>

          <DateTimePicker
            onChange={(dateTime) =>
            this.onChange(index, 'endDateTime', dateTime)
            }
            value={endDateTime}
            name="endDateTime" />


        },
        {
          title: 'Контактные лица',
          key: 'contactEmployees',
          render: (
          contactEmployees,
          record,
          index) =>

          <TextArea
            onChange={(e) =>
            this.onChange(index, 'contactEmployees', e.target.value)
            }
            value={contactEmployees}
            name="name"
            autosize={{ minRows: 1 }} />


        },
        {
          width: '20px',
          renderRecord: (record, index) =>
          !isEmpty(record) ?
          <Operations>
                  {record.id ?
            <Popconfirm
              title="Вы уверены, что хотите удалить?"
              onConfirm={async () => {
                if (record.id)
                await loadUnloadCargoApi.deleteLoadUnloadCargo(
                  record.id
                );
                this.onDelete(index);
              }}>

                      <StyledIcon type="x" />
                    </Popconfirm> :

            <StyledIcon onClick={() => this.onDelete(index)} type="x" />
            }
                </Operations> :
          null
        }]
        }
        data={withEmptyRow(loadUnloads)} />);


  }
}

export default LoadUnloadCargosForm;